import { render, staticRenderFns } from "./GridDropdownMenu.vue?vue&type=template&id=8b3d122a&"
import script from "./GridDropdownMenu.vue?vue&type=script&lang=js&"
export * from "./GridDropdownMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports